import { withDelay } from 'client/common/delay'
import { setAnalyticListType } from 'client/common/analytic/useXSellAnalytic'
import { dispatchPageBusEvent } from 'client/common/pageBus'
import {
  BONUS_BUYS_LIST_TYPE,
  BONUS_BUYS_LISTER_IMPRESSIONS_PRODUCT,
  BONUS_BUYS_LISTER_PRODUCT_CLICKED,
  CUSTOM_LIST_TYPE,
  CUSTOM_LISTER_IMPRESSIONS_PRODUCT,
  CUSTOM_LISTER_PRODUCT_CLICKED,
  HANDLE_FILTER_CLICK,
  HANDLE_VIEW_LISTER_PAGE_EVENT,
  LISTER_IMPRESSIONS_PRODUCT,
  LISTER_LIST_TYPE,
  LISTER_PRODUCT_CLICKED,
  SEARCH_IMPRESSIONS_PRODUCT,
  SEARCH_LIST_TYPE,
  SEARCH_PRODUCT_CLICKED
} from 'client/common/analytic/analytic'

import { createListenerMiddleware } from '@reduxjs/toolkit'
import { setData } from 'client/fragments/listerFragment/store/reducer'
import { fireMiraklImpression, fireMiraklClick } from './mirakl'

const isCustomLister = () => /(collectie|nl\/collectie|fr\/collection)/.test(window?.location?.href)
const isBonusBuysLister = () =>
  /(acties\/aanbiedingen|nl\/promotie\/aanbiedingen|fr\/action\/offres)/.test(window?.location?.href)

export const getType = term => {
  if (isCustomLister()) return CUSTOM_LISTER_IMPRESSIONS_PRODUCT
  if (isBonusBuysLister()) return BONUS_BUYS_LISTER_IMPRESSIONS_PRODUCT
  if (term) return SEARCH_IMPRESSIONS_PRODUCT
  return LISTER_IMPRESSIONS_PRODUCT
}

export const handleHintClick = eventLabel => {
  const data = {
    eventAction: 'hint',
    eventLabel
  }
  dispatchPageBusEvent({ type: HANDLE_FILTER_CLICK, data })
}

const dispatchPageBusEventOfType = type => data => dispatchPageBusEvent({ type, data })

export const handleViewListerEvent = dispatchPageBusEventOfType(HANDLE_VIEW_LISTER_PAGE_EVENT)

const fireProductImpressions = props => {
  const { term, categoryCode, page, viewSize, products = 24, meta } = props
  const { resultType } = meta
  const data = {
    products: {
      collection: products.collection,
      viewSize,
      page: page.page
    },
    ...(!!resultType && { listType: `${resultType}-results` })
  }
  term && (data.searchTerm = term)
  categoryCode && (data.categoryCode = categoryCode)
  dispatchPageBusEvent({ type: getType(term), data })

  fireMiraklImpression(products)
}

export const fireProductClick = (categoryCode, data, resultType) => {
  if (isCustomLister()) {
    dispatchPageBusEvent({ type: CUSTOM_LISTER_PRODUCT_CLICKED, data })
    setAnalyticListType(CUSTOM_LIST_TYPE, data)
  } else if (isBonusBuysLister()) {
    dispatchPageBusEvent({ type: BONUS_BUYS_LISTER_PRODUCT_CLICKED, data })
    setAnalyticListType(BONUS_BUYS_LIST_TYPE, data)
  } else if (categoryCode) {
    dispatchPageBusEvent({ type: LISTER_PRODUCT_CLICKED, data })
    setAnalyticListType(LISTER_LIST_TYPE, data)
    fireMiraklClick(data.adId)
  } else {
    let listType = SEARCH_LIST_TYPE
    if (resultType) {
      listType = `${resultType}-results`
    }
    dispatchPageBusEvent({
      type: SEARCH_PRODUCT_CLICKED,
      data: {
        ...data,
        listType
      }
    })
    setAnalyticListType(listType, data)
    fireMiraklClick(data.adId)
  }
}

export const processWithGtm = state => {
  withDelay(
    () => fireProductImpressions(state.data),
    () => window && window.dataLayer && window.dataLayer.filter(item => item.event === 'pageLoad').length > 0
  )
}

export const listenerMiddleware = createListenerMiddleware()

listenerMiddleware.startListening({
  actionCreator: setData,
  effect: async (action, listenerApi) => {
    if (action.payload.products) {
      processWithGtm(listenerApi.getState())
    }
  }
})
